export default function translate(i18n, propriete) {
  if (propriete === 'echeancier.dateDebut') return i18n.t('echeancierFacturation.messages.errors.required.dateDebut');
  if (propriete === 'echeancier.dateFin') return i18n.t('echeancierFacturation.messages.errors.required.dateFin');
  if (propriete === 'echeancier.quantitePeriodicite') return i18n.t('echeancierFacturation.messages.errors.required.quantitePeriodicite');
  if (propriete === 'montant') return i18n.t('echeancierFacturation.messages.errors.required.montant');
  if (propriete.toLowerCase().indexOf('repartition') > -1) return i18n.t('echeancierFacturation.messages.errors.required.quotePart');
  return propriete;
}
